import { Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Container maxWidth="sm" sx={{ py: 10 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h1">404</Typography>
        <Typography variant="body1" color="text.secondary">
          That page does not exist.
        </Typography>
        <Button component={Link} to="/" variant="contained">
          Back to status
        </Button>
      </Stack>
    </Container>
  );
}
